import { AnimatePresence } from "framer-motion";
import { useRouter } from "next/router";
import { ANNOUNCEMENT_TYPES } from "../../constants";
import { useAnnouncementsStore } from "../../store";
import { getAnnouncementTranslation } from "../../utils";
import { AnnouncementBanner } from "../AnnouncementBanner";

export const GlobalAnnouncement = () => {
    const { locale } = useRouter();
    const {
        previewAnnouncement,
        liveAnnouncement,
        setPreviewAnnouncement,
    } = useAnnouncementsStore();

    const announcement = previewAnnouncement ?? liveAnnouncement;
    const isPreview = !!previewAnnouncement;
    const isBanner = announcement?.type === ANNOUNCEMENT_TYPES.BANNER;

    const translation = announcement?.translations?.length
        ? getAnnouncementTranslation(announcement.translations, locale)
        : undefined;
    const title = translation?.title ?? announcement?.title ?? "";
    const description = translation?.description ?? announcement?.description ?? "";

    return (
        <AnimatePresence>
            {isBanner && (
                <AnnouncementBanner
                    title={title}
                    description={description}
                    onClose={() => {
                        if (isPreview) {
                            setPreviewAnnouncement(null);
                        } else {
                            announcement.onHide?.();
                        }
                    }}
                />
            )}
        </AnimatePresence>
    );
};
